module.exports = __webpack_public_path__ + "img/6.618bd3a9.png";